import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { CountersApi } from '../api/counters.api';
import { CountersData, CountersValue } from '../../../interfaces/solar/counters';

@Injectable()
export class CountersService extends CountersData {

  constructor(private api: CountersApi) {
    super();
  }

  getData(params): Observable<CountersValue[]> {
    return this.api.getData(params);
  }

  getStat(params): Observable<CountersValue[]> {
    return this.api.getStat(params);
  }
}
